// extracted by mini-css-extract-plugin
export default {"layoutSwitch":"InspirationsNavigation_layoutSwitch__jfBAf","paginationSwitch":"InspirationsNavigation_paginationSwitch__YliHj"};